<main class="unlogged">
  <ng-content></ng-content>
</main>
